<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="staffGroupAudits && staffGroupAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="staffGroupAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Staff Group audits </ng-template>
</ng-template>
